'use client';
import {Experience, Education, FormData} from "@/types/career";
import { useState } from "react";

const labelClass = "block text-[11px] font-semibold text-gray-600 uppercase tracking-[0.15em] mb-1.5";

export function Field({
  label, required, children,
}: { label: string; required?: boolean; children: React.ReactNode }) {
  return (
    <div>
      <label className={labelClass}>
        {label} {required && <span className="text-brand-warn">*</span>}
      </label>
      {children}
    </div>
  );
}
